import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useDispatch, useSelector } from 'react-redux';
import * as searchActions from '../../redux/actions/searchActions';
import * as constants from '../../Constants/Search';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import { useState } from 'react';
import SubjectIcon from '@material-ui/icons/Subject';
import WebAssetIcon from '@material-ui/icons/WebAsset';
import ViewModuleIcon from '@material-ui/icons/ViewModule';

//Category select drop-down data mapping object
const categorySelectionOptions = [
	{
		display: constants.assets3dDisplayTxt,
		value: constants.assets3dVal,
		icon: <WebAssetIcon color="primary" />,
	},
	{
		display: constants.productDisplayTxt,
		value: constants.productVal,
		icon: <SubjectIcon color="primary"></SubjectIcon>,
	},
	{
		display: constants.allDisplayTxt,
		value: constants.allVal,
		icon: <ViewModuleIcon color="primary" />,
	},
];

const useStyles = makeStyles((theme) => ({
	select: {
		width: '100%',
	},
	mySearchQueriesLabel: {
		position: 'absolute',
		whiteSpace: 'nowrap',
	},
	filters: {
		cursor: 'pointer',
	},
	filterContainer: {
		float: 'right',
		left: '-8em',
		position: 'relative',
		top: '-2.5em',
	},
	mySearchQuery: {
		position: 'absolute',
		left: '5em',
		top: '4em',
		cursor: 'pointer',
	},
	searchToolTip: {},
	categoryOption: {
		display: 'flex',
		alignItems: 'center',
	},
	categoryOptionDisplay: {
		marginLeft: '0.25rem',
	},
}));

//category selection component for search and results page.
export default function CategorySelectionDropdown(props) {
	const searchTerm = useSelector((state) => state.search.searchTerm);
	//Category Selection dropdown
	const RenderCategorySelection = () => {
		const classes = useStyles();
		const [open, setOpen] = useState(false);
		const selectedCategory = useSelector((state) => state.search.category);
		const dispatch = useDispatch();
		//updating selection state in redux store
		const handleChange = (event) => {
			const selectedCategoryValue = event.target.value;
			dispatch(searchActions.setSearchCategory(selectedCategoryValue));
			if (
				props.DebounceLoadSearchAutoCompleteData !== undefined &&
				searchTerm.length > 0 &&
				searchTerm !== null
			) {
				props.DebounceLoadSearchAutoCompleteData(searchTerm, selectedCategoryValue);
			}
		};

		const handleClose = () => {
			setOpen(false);
		};

		const handleOpen = () => {
			setOpen(true);
		};
		const RenderMenuItems = (option) => {
			return (
				<MenuItem className={classes.categoryOption} value={option.value} key={option.value}>
					{option.icon}
					<span className={classes.categoryOptionDisplay}>{option.display}</span>
				</MenuItem>
			);
		};
		return (
			<Select
				className={classes.select}
				labelId="category-controlled-open-select-label"
				id="category-controlled-open-select"
				data-cy="category-controlled-open-select"
				open={open}
				onClose={handleClose}
				onOpen={handleOpen}
				value={selectedCategory}
				defaultValue={constants.assets3dVal}
				onChange={handleChange}
				variant="outlined"
			>
				{/* rendering select inputs from mapping object */}
				{categorySelectionOptions.map((option) => {
					return RenderMenuItems(option);
				})}
			</Select>
		);
	};

	return <RenderCategorySelection />;
}
